import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Belgaumtosirsicabstaxi() {



    const cardData = {




keyword: "Belgaum to Sirsi Cabs Taxi",

headingDescription: "Belgaum Taxi Service offers comfortable and reliable Belgaum to Sirsi cab services for family trips, business travel, pilgrimage visits, sightseeing tours, and outstation journeys. We provide one-way taxi, round-trip cab, and customized travel options from Belgaum to Sirsi with experienced drivers and well-maintained vehicles. Our fleet includes Sedan, Swift Dzire, Ertiga, SUV, Innova, Innova Crysta, Tempo Traveller, and premium cars suitable for individuals, families, and groups. With doorstep pickup, flexible travel timings, transparent pricing, easy booking, and 24/7 customer support, we ensure a smooth and safe journey between Belgaum and Sirsi. Whether you are traveling for work, family functions, temple visits, nature trips, or exploring North Karnataka destinations, Belgaum Taxi Service provides dependable cab solutions with professional chauffeurs, clean vehicles, and comfortable long-distance travel facilities.",

topPlaces: [
  {
    title: "Sirsi",
    description: "Sirsi is a beautiful town in Uttara Kannada district known for its lush greenery, waterfalls, temples, forests, and rich cultural heritage. It is an important destination for travelers exploring the natural beauty of Karnataka. The town is famous for its peaceful environment, local markets, and connectivity to several scenic attractions."
  },
  {
    title: "Marikamba Temple",
    description: "Marikamba Temple is one of the most famous temples in Sirsi dedicated to Goddess Marikamba. The temple holds great religious importance and attracts thousands of devotees during festivals and special occasions. It is a major spiritual attraction for visitors traveling to Sirsi."
  },
  {
    title: "Unchalli Falls",
    description: "Unchalli Falls is a spectacular waterfall near Sirsi known for its natural beauty, forest surroundings, and peaceful atmosphere. It is a popular destination for nature lovers, photographers, and travelers looking for a refreshing getaway."
  },
  {
    title: "Sahasralinga",
    description: "Sahasralinga is a unique religious and natural attraction near Sirsi where thousands of Shiva lingas are carved on rocks along the Shalmala River. It is an important pilgrimage and sightseeing destination surrounded by beautiful forest landscapes."
  },
  {
    title: "Yana Caves",
    description: "Yana Caves is a famous natural attraction near Sirsi known for massive black limestone rock formations, trekking trails, dense forests, and scenic views. It is a preferred destination for adventure lovers and nature enthusiasts."
  },
  {
    title: "Gokarna",
    description: "Gokarna is a popular coastal destination near Sirsi famous for Mahabaleshwar Temple, Om Beach, Kudle Beach, and beautiful Arabian Sea views. It is a perfect destination for travelers combining spiritual visits with beach holidays."
  },
  {
    title: "Jog Falls",
    description: "Jog Falls is one of India's highest waterfalls and a major tourist attraction in Karnataka. The breathtaking waterfall views, surrounding greenery, and peaceful environment make it a favorite destination for families and photographers."
  },
  {
    title: "Dandeli",
    description: "Dandeli is a famous adventure and wildlife destination known for forests, wildlife sanctuary, river rafting, jungle safari, and outdoor activities. It is an excellent choice for travelers planning a nature and adventure tour."
  },
  {
    title: "Murudeshwar",
    description: "Murudeshwar is a famous coastal pilgrimage destination known for the giant Shiva statue, Murudeshwar Temple, beaches, and Arabian Sea views. It is a popular destination for families and religious travelers."
  },
  {
    title: "Goa",
    description: "Goa is a world-famous holiday destination known for beaches, resorts, churches, nightlife, water sports, and scenic coastal attractions. Travelers often combine Sirsi with Goa for an extended Karnataka coastal tour."
  }
],




 "services": [
    {
      "name": "Belgaum to Sirsi Cabs Taxi",
      "description": "Book Belgaum to Sirsi Cabs Taxi for safe, comfortable, and reliable outstation travel with professional chauffeurs and well-maintained AC vehicles. Get Sedan, Ertiga, Innova Crysta, and SUV cab options for family trips, business travel, sightseeing, and convenient journeys between Belgaum and Sirsi with flexible one way and round trip booking facilities."
    },
    {
      "name": "Belgaum to Sirsi Cab",
      "description": "Hire Belgaum to Sirsi Cab service for a smooth and hassle-free journey with experienced drivers, clean vehicles, and affordable travel packages. Our cabs provide comfortable transportation for personal trips, family tours, corporate travel, and long-distance travel requirements."
    },
    {
      "name": "Belgaum to Sirsi Taxi",
      "description": "Choose Belgaum to Sirsi Taxi for reliable intercity transportation with professional drivers, transparent pricing, and multiple vehicle options. Travel comfortably with Sedan, Ertiga, and Innova Crysta taxis available for one way and round trip journeys."
    },
    {
      "name": "Belgaum to Sirsi Cab Service",
      "description": "Book Belgaum to Sirsi Cab Service for convenient outstation travel with doorstep pickup, experienced chauffeurs, and well-maintained vehicles. Our taxi services are suitable for families, corporate passengers, sightseeing trips, and comfortable travel needs."
    },
    {
      "name": "Belgaum to Sirsi Taxi Service",
      "description": "Get Belgaum to Sirsi Taxi Service with comfortable AC cars, professional drivers, affordable fares, and flexible booking options. Enjoy a safe and convenient journey from Belgaum to Sirsi for business, personal, and family travel."
    },
    {
      "name": "Belgaum to Sirsi One Way Cab",
      "description": "Book Belgaum to Sirsi One Way Cab for economical single-trip travel without return charges. Enjoy fixed pricing, comfortable seating, clean vehicles, and reliable chauffeur services for your one way journey."
    },
    {
      "name": "Belgaum to Sirsi One Way Taxi",
      "description": "Choose Belgaum to Sirsi One Way Taxi for affordable and convenient transportation with professional drivers and flexible pickup options. Perfect for passengers looking for budget-friendly one direction travel solutions."
    },
    {
      "name": "Belgaum to Sirsi Cab Booking",
      "description": "Complete Belgaum to Sirsi Cab Booking online with easy reservations, quick confirmation, and multiple vehicle choices. Select from Sedan, Ertiga, Innova Crysta, and premium cabs according to your travel requirements."
    },
    {
      "name": "Belgaum to Sirsi Taxi Booking",
      "description": "Reserve Belgaum to Sirsi Taxi Booking services for comfortable and reliable travel with experienced chauffeurs. Get affordable taxi options with flexible schedules for local, family, and corporate journeys."
    },
    {
      "name": "Belgaum to Sirsi Car Rental",
      "description": "Choose Belgaum to Sirsi Car Rental for private chauffeur-driven vehicles with comfortable seating and professional service. Ideal for business trips, family travel, sightseeing, and outstation transportation."
    },
    {
      "name": "Belgaum to Sirsi Outstation Cab",
      "description": "Hire Belgaum to Sirsi Outstation Cab for safe and comfortable long-distance travel. Enjoy reliable transportation with AC vehicles, skilled drivers, transparent fares, and flexible one way or round trip packages."
    },
    {
      "name": "Belgaum to Sirsi Innova Crysta Cab",
      "description": "Book Belgaum to Sirsi Innova Crysta Cab for premium and spacious travel with luxury seating, large luggage capacity, and experienced chauffeurs. Perfect for family groups, corporate travel, and comfortable outstation journeys."
    },
    {
      "name": "Belgaum to Sirsi Ertiga Cab",
      "description": "Choose Belgaum to Sirsi Ertiga Cab for affordable 6 to 7 seater travel with spacious interiors and comfortable seating. Ideal for family trips, sightseeing tours, airport transfers, and long-distance journeys."
    },
    {
      "name": "Belgaum to Sirsi Sedan Cab",
      "description": "Book Belgaum to Sirsi Sedan Cab for economical and comfortable travel with clean AC vehicles and professional drivers. Suitable for individuals, couples, business trips, and smooth highway journeys."
    },
    {
      "name": "Belgaum to Sirsi Round Trip Cab",
      "description": "Hire Belgaum to Sirsi Round Trip Cab for convenient return journeys with affordable packages and flexible travel schedules. Perfect for family visits, sightseeing, weekend trips, and personal travel."
    },
    {
      "name": "Belgaum to Sirsi Private Taxi",
      "description": "Reserve Belgaum to Sirsi Private Taxi for a personalized travel experience with dedicated vehicles and professional chauffeurs. Enjoy privacy, comfort, and hassle-free transportation throughout your journey."
    },
    {
      "name": "Cheap Belgaum to Sirsi Cab",
      "description": "Find Cheap Belgaum to Sirsi Cab services offering affordable fares without compromising safety and comfort. Get reliable vehicles, experienced drivers, and budget-friendly travel solutions."
    },
    {
      "name": "Best Belgaum to Sirsi Taxi Service",
      "description": "Choose the Best Belgaum to Sirsi Taxi Service with premium vehicles, trained drivers, competitive pricing, and dependable customer support. Experience smooth and comfortable travel for all types of journeys."
    },
    {
      "name": "Online Belgaum to Sirsi Cab Booking",
      "description": "Complete Online Belgaum to Sirsi Cab Booking with simple reservations, instant confirmation, and flexible travel options. Select your preferred vehicle and enjoy convenient doorstep pickup service."
    },
    {
      "name": "Belgaum to Sirsi Taxi Fare",
      "description": "Check Belgaum to Sirsi Taxi Fare for affordable and transparent pricing with no hidden charges. Get comfortable cabs with professional drivers for safe and economical travel."
    },
    {
      "name": "Belgaum to Sirsi Car Hire",
      "description": "Hire Belgaum to Sirsi Car Hire services for comfortable private travel with chauffeur-driven vehicles. Choose from multiple car categories for personal, family, and corporate transportation needs."
    },
    {
      "name": "Belgaum to Sirsi Cab Price",
      "description": "Get affordable Belgaum to Sirsi Cab Price with flexible packages for one way and round trips. Enjoy quality vehicles, reliable service, and professional drivers at competitive rates."
    },
    {
      "name": "Belgaum to Sirsi Family Cab",
      "description": "Book Belgaum to Sirsi Family Cab for safe and comfortable family travel with spacious vehicles and experienced chauffeurs. Perfect for vacations, family functions, temple visits, and personal journeys."
    },
    {
      "name": "Belgaum to Sirsi Corporate Taxi",
      "description": "Choose Belgaum to Sirsi Corporate Taxi services for business travel and executive journeys. Get punctual service with professional drivers and well-maintained vehicles."
    },
    {
      "name": "Belgaum to Sirsi Airport Transfer",
      "description": "Book Belgaum to Sirsi Airport Transfer services for timely airport pickup and drop with comfortable vehicles and professional chauffeurs. Enjoy stress-free airport transportation with reliable cab availability."
    },
    {
      "name": "Belgaum to Sirsi Cab Fare",
      "description": "Get the best Belgaum to Sirsi Cab Fare with affordable travel packages and transparent pricing. Travel comfortably with Sedan, Ertiga, Innova Crysta, and SUV cab options."
    },
    {
      "name": "Belgaum to Sirsi Taxi Near Me",
      "description": "Find Belgaum to Sirsi Taxi Near Me for quick and reliable cab availability with professional drivers. Enjoy convenient booking, doorstep pickup, and comfortable travel anytime."
    },
    {
      "name": "Belgaum to Sirsi Outstation Taxi",
      "description": "Book Belgaum to Sirsi Outstation Taxi for safe and convenient long-distance travel. Get clean AC vehicles, experienced chauffeurs, and flexible travel plans for personal and business journeys."
    },
    {
      "name": "Belgaum to Sirsi Travel by Cab",
      "description": "Experience comfortable Belgaum to Sirsi Travel by Cab with reliable transportation, professional drivers, and premium vehicle options. Enjoy a smooth journey with convenient pickup and customized travel solutions."
    }
  ],
  "tableData": [
    ["Belgaum to Sirsi Cabs Taxi", "Belgaum to Sirsi Cab"],
    ["Belgaum to Sirsi Taxi", "Belgaum to Sirsi Cab Service"],
    ["Belgaum to Sirsi Taxi Service", "Belgaum to Sirsi One Way Cab"],
    ["Belgaum to Sirsi One Way Taxi", "Belgaum to Sirsi Cab Booking"],
    ["Belgaum to Sirsi Taxi Booking", "Belgaum to Sirsi Car Rental"],
    ["Belgaum to Sirsi Outstation Cab", "Belgaum to Sirsi Innova Crysta Cab"],
    ["Belgaum to Sirsi Ertiga Cab", "Belgaum to Sirsi Sedan Cab"],
    ["Belgaum to Sirsi Round Trip Cab", "Belgaum to Sirsi Private Taxi"],
    ["Cheap Belgaum to Sirsi Cab", "Best Belgaum to Sirsi Taxi Service"],
    ["Online Belgaum to Sirsi Cab Booking", "Belgaum to Sirsi Taxi Fare"],
    ["Belgaum to Sirsi Car Hire", "Belgaum to Sirsi Cab Price"],
    ["Belgaum to Sirsi Family Cab", "Belgaum to Sirsi Corporate Taxi"],
    ["Belgaum to Sirsi Airport Transfer", "Belgaum to Sirsi Cab Fare"],
    ["Belgaum to Sirsi Taxi Near Me", "Belgaum to Sirsi Outstation Taxi"],
    ["Belgaum to Sirsi Travel by Cab", ""]
  ],





whychoose: [
  {
    WhyChooseheading: "Reliable Belgaum to Sirsi Cabs Taxi Service",
    WhyChoosedescription: "Travel from Belgaum to Sirsi with a dependable cab service offering comfortable vehicles, experienced drivers, and flexible travel options for personal, family, and sightseeing journeys."
  },
  {
    WhyChooseheading: "Convenient Doorstep Pickup Facility",
    WhyChoosedescription: "Get easy pickup from your home, hotel, office, railway station, airport area, or preferred location in Belgaum with direct drop service in Sirsi."
  },
  {
    WhyChooseheading: "Comfortable Cars for Every Group",
    WhyChoosedescription: "Choose from Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, and SUV cabs based on passenger count, luggage space, and travel comfort requirements."
  },
  {
    WhyChooseheading: "Perfect for Nature & Temple Trips",
    WhyChoosedescription: "Our Belgaum to Sirsi taxis are suitable for travellers visiting waterfalls, temples, nature destinations, family outings, and weekend getaways."
  },
  {
    WhyChooseheading: "Experienced Drivers for Smooth Travel",
    WhyChoosedescription: "Professional chauffeurs provide safe driving, timely service, and comfortable rides with good knowledge of highway and coastal routes."
  },
  {
    WhyChooseheading: "One Way & Round Trip Booking Options",
    WhyChoosedescription: "Select a one-way taxi for direct travel or arrange a round-trip cab according to your schedule and travel requirements."
  },
  {
    WhyChooseheading: "Clean & Well-Maintained Vehicles",
    WhyChoosedescription: "Enjoy your journey in hygienic vehicles with spacious seating and regular maintenance for a comfortable long-distance trip."
  },
  {
    WhyChooseheading: "Simple Cab Booking Process",
    WhyChoosedescription: "Get quick assistance for taxi availability, vehicle selection, and fare details to plan your Belgaum to Sirsi cab journey easily."
  }
]

};

const faqData = [
  {
    question: "Does Belgaum Taxi Service provide Belgaum to Sirsi Cabs Taxi?",
    answer: "Yes, we provide Belgaum to Sirsi cab services with comfortable vehicles and professional drivers for outstation travel."
  },
  {
    question: "Can I book a one-way taxi from Belgaum to Sirsi?",
    answer: "Yes, one-way taxi services are available for passengers who need direct transportation between Belgaum and Sirsi."
  },
  {
    question: "Which vehicles are available for Belgaum to Sirsi travel?",
    answer: "You can choose from Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, and SUV cabs according to your travel needs."
  },
  {
    question: "Is Belgaum to Sirsi cab suitable for family trips?",
    answer: "Yes, comfortable and spacious vehicles are available for families, senior citizens, and groups travelling to Sirsi."
  },
  {
    question: "Can I book a return cab from Sirsi to Belgaum?",
    answer: "Yes, return journey taxi options are available with flexible timings according to your travel plan."
  },
  {
    question: "Do you provide pickup from Belgaum Airport and Railway Station?",
    answer: "Yes, pickup and drop facilities are available from Belgaum Airport, Railway Station, hotels, homes, and other preferred locations."
  },
  {
    question: "Can I include sightseeing during my Sirsi trip?",
    answer: "Yes, sightseeing stops and customized travel plans can be arranged according to your itinerary."
  },
  {
    question: "Are toll and parking charges included in the taxi fare?",
    answer: "Applicable toll, parking, and additional travel charges depend on the selected package and are explained during booking."
  },
  {
    question: "Is Belgaum to Sirsi taxi service available 24/7?",
    answer: "Yes, taxi booking assistance is available for planned journeys and urgent travel requirements."
  },
  {
    question: "How can I book a Belgaum to Sirsi Cab?",
    answer: "Share your pickup location, travel date, passenger details, and preferred vehicle type to receive fare details and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rahul Naik",
    feedback: "The Belgaum to Sirsi cab service was very comfortable. The driver was punctual, and the vehicle was clean and well maintained throughout the journey.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Aarti Kulkarni",
    feedback: "We booked a cab for a family trip to Sirsi and had a smooth experience. The spacious vehicle and professional service made our journey enjoyable.",
    rating: 5
  }
];


    const Images = [
        { place: "/images/keyword/1.jpg", text: "Cab Service in Belgaum", link: "Cab-Service-in-Belgaum" },
        { place: "/images/keyword/2.jpg", text: "Belgaum Taxi Service", link: "Belgaum-Taxi-Service" },
        { place: "/images/keyword/3.jpg", text: "Belgaum to Goa Cab", link: "Belgaum-to-Goa-Cab" },
        { place: "/images/keyword/4.jpg", text: "Belgaum to Mahabaleshwar Cab", link: "Belgaum-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Belgaum to Kerala Cab Service", link: "Belgaum-to-Kerala-Cab-Service" },
        { place: "/images/keyword/6.jpg", text: "Goa to Belgaum Cab", link: "Goa-to-Belgaum-Cab" },
        { place: "/images/keyword/7.jpg", text: "Belgaum to Mumbai Cab", link: "Belgaum-to-Mumbai-Cab" },
        { place: "/images/keyword/8.jpg", text: "Belgaum to Bangalore Cab", link: "Belgaum-to-Bangalore-Cab" },
        { place: "/images/keyword/9.jpg", text: "Goa Cab Service", link: "Goa-Cab-Service" },
        { place: "/images/keyword/10.jpg", text: "Taxi Service in Goa", link: "Taxi-Service-in-Goa" },
        { place: "/images/keyword/11.jpg", text: "Cheapest Cab Service in Goa", link: "Cheapest-Cab-Service-in-Goa" },
        { place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Belgaum", link: "Corporate-Cab-Services-in-Belgaum" },
        { place: "/images/keyword/13.jpg", text: "Innova Crysta Rent in Belgaum", link: "Innova-Crysta-Rent-in-Belgaum" },
        { place: "/images/keyword/14.jpg", text: "Ertiga on Rent in Belgaum", link: "Ertiga-on-Rent-in-Belgaum" },
        { place: "/images/keyword/15.jpg", text: "Tempo Traveller Rent in Belgaum", link: "Tempo-Traveller-Rent-in-Belgaum" },
        { place: "/images/keyword/16.jpg", text: "Mini Bus Rental Belgaum", link: "Mini-Bus-Rental-Belgaum" },
        { place: "/images/keyword/17.jpg", text: "Swift Dzire on Rent in Belgaum", link: "Swift-Dzire-on-Rent-in-Belgaum" },
        { place: "/images/keyword/18.jpg", text: "Urbania on Rent in Belgaum", link: "Urbania-on-Rent-in-Belgaum" },
        { place: "/images/keyword/19.jpg", text: "Wedding Car Rental in Belgaum", link: "Wedding-Car-Rental-in-Belgaum" },
        { place: "/images/keyword/20.jpg", text: "Cabs in Belgaum", link: "Cabs-in-Belgaum" },
        { place: "/images/keyword/21.jpg", text: "Belgaum to Hubli Cab", link: "Belgaum-to-Hubli-Cab" },
        { place: "/images/keyword/22.jpg", text: "Belgaum to Dharwad Cab", link: "Belgaum-to-Dharwad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Belgaum to Kolhapur Cab", link: "Belgaum-to-Kolhapur-Cab" },
        { place: "/images/keyword/24.jpg", text: "Belgaum Airport Cab Service", link: "Belgaum-Airport-Cab-Service" },
        { place: "/images/keyword/25.jpg", text: "Belgaum to Bagalkot Cab", link: "Belgaum-to-Bagalkot-Cab" },
    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Belgaum to Sirsi Cabs Taxi",
  "image": "https://www.belgaumtaxiservice.com/assets/images/belgaum-to-sirsi-cabs-taxi.webp",
  "description":
    "Book Belgaum to Sirsi Cabs Taxi with Belgaum Taxi Service for safe, comfortable, and affordable outstation taxi services. We provide one-way and round-trip cabs from Belgaum to Sirsi with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for business travel, family trips, temple visits, sightseeing, and long-distance journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Belgaum Taxi Service"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.belgaumtaxiservice.com/belgaum-to-sirsi-cabs-taxi"
  }
};




    return (
        <div>




<Helmet>
  <title>Belgaum to Sirsi Cabs Taxi | 24x7 Cab Booking | +91 8722158435</title>

  <meta
    name="description"
    content="Book Belgaum to Sirsi Cabs Taxi with Belgaum Taxi Service for reliable one-way and round-trip taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs for affordable and comfortable outstation travel from Belgaum to Sirsi with 24x7 online cab booking."
  />

  <meta
    name="keywords"
    content="Belgaum to Sirsi Cabs Taxi, Belgaum to Sirsi Cab, Belgaum to Sirsi Taxi, Belgaum to Sirsi Cab Service, Belgaum to Sirsi Taxi Service, Belgaum to Sirsi One Way Cab, Belgaum to Sirsi One Way Taxi, Belgaum to Sirsi Cab Booking, Belgaum to Sirsi Taxi Booking, Belgaum to Sirsi Car Rental, Belgaum to Sirsi Outstation Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




            <div className="page-headder bg-section parallaxie">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="page-header-box text-white">
                                <h1 className="text-anime-style-3 text-center text-white">
                                    {cardData.keyword}
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>













            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/59.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Belgaum Taxi Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Belgaum Taxi Service</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Belgaum Taxi Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918722158435 " className="pc-call">+91 8722158435 </a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918722158435 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918722158435 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@belgaumtaxiservice.com" className="pc-email">
                                            booking@belgaumtaxiservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Belgaum Taxi Service</strong><br />
                                            P No 30 cCTS No 7023,
                                            Sector No 9 Malmaruti Anjaneya Nagar,
                                            Belgaum, Karnataka - 590017




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Belgaumtosirsicabstaxi ;